import { render, staticRenderFns } from "./CountingChart.vue?vue&type=template&id=4ed56194&scoped=true"
import script from "./CountingChart.vue?vue&type=script&lang=js"
export * from "./CountingChart.vue?vue&type=script&lang=js"
import style0 from "./CountingChart.vue?vue&type=style&index=0&id=4ed56194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed56194",
  null
  
)

export default component.exports